import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";

const AdminLogin = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-sm flex items-center justify-center mx-auto mb-4">
            <Lock size={20} className="text-white" />
          </div>
          <h1 className="text-2xl font-extrabold tracking-tighter text-white">Admin Dashboard</h1>
          <p className="text-zinc-500 text-sm mt-2">Sign in to manage the ICT Summit</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-zinc-900 border border-zinc-800 p-8 space-y-5" data-testid="admin-login-form">
          {error && (
            <div className="bg-red-500/10 border border-red-500/20 text-red-400 text-sm px-4 py-3" data-testid="login-error">
              {error}
            </div>
          )}

          <div>
            <label className="text-xs uppercase tracking-[0.15em] text-zinc-500 font-medium block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-zinc-900 border border-zinc-800 px-4 py-3 text-white text-sm focus:outline-none focus:ring-1 focus:ring-teal-500 focus:border-teal-500"
              placeholder="admin@ictsummit.com.ng"
              required
              data-testid="login-email-input"
            />
          </div>

          <div>
            <label className="text-xs uppercase tracking-[0.15em] text-zinc-500 font-medium block mb-2">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-zinc-900 border border-zinc-800 px-4 py-3 text-white text-sm focus:outline-none focus:ring-1 focus:ring-teal-500 focus:border-teal-500"
              placeholder="Enter password"
              required
              data-testid="login-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-teal-600 hover:bg-teal-500 text-white py-3 font-semibold tracking-wide transition-all flex items-center justify-center gap-2 disabled:opacity-50"
            data-testid="login-submit-btn"
          >
            {loading ? <><Loader2 size={18} className="animate-spin" /> Signing in...</> : "Sign In"}
          </button>
        </form>

        <div className="text-center mt-6">
          <a href="/" className="text-zinc-500 hover:text-teal-400 text-sm transition-colors">Back to website</a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
